function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43.236 22.194c1.965 2.134 3.103 4.663 3.103 7.374 0 3.7-2.118 7.06-5.568 9.541m-29.229-.019C8.107 36.61 6 33.258 6 29.568c0-2.757 1.176-5.325 3.203-7.482"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.338-1.334s.084 3.58.13 7.62c.036 3.114.048 6.5-.019 8.73-.154 5.123-.584 5.11 0 14.386s7.486 20.269 16.72 20.269c9.234 0 16.136-10.679 16.72-20.269.584-9.59.156-9.5 0-14.622S43-1.334 43-1.334L35 8s-2-1-8.83-1.459C19 7 17.316 8.25 17.316 8.25zM11.7 5s2.316 2.742 3.3 4l-3.3 3zm29.1 0v7L37 9c2-2 3.8-4 3.8-4z"
}), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 0.868
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.298 49.458c0 1.288-.413 3.457-1.66 3.457-1.246 0-1.659-2.593-1.659-2.593s-.26 2.593-1.66 2.593c-1.165 0-1.66-2.593-1.66-2.593s-.412 2.593-1.659 2.593-1.66-2.169-1.66-3.457c0-1.289.632-3.417 1.66-3.458 1.028-.041 1.66 1.729 1.66 1.729s.366-2.593 1.66-2.593c1.191 0 1.659 2.593 1.659 2.593s.632-1.77 1.66-1.729c1.028.041 1.66 2.17 1.66 3.458zM28.17 49.458c0 1.288.414 3.457 1.66 3.457 1.247 0 1.66-2.593 1.66-2.593s.26 2.593 1.66 2.593c1.165 0 1.66-2.593 1.66-2.593s.412 2.593 1.659 2.593 1.66-2.169 1.66-3.457c0-1.289-.632-3.417-1.66-3.458-1.028-.041-1.66 1.729-1.66 1.729s-.366-2.593-1.66-2.593c-1.191 0-1.659 2.593-1.659 2.593s-.632-1.77-1.66-1.729c-1.028.041-1.66 2.17-1.66 3.458z",
  strokeWidth: 1.00040472
})), /*#__PURE__*/React.createElement("path", {
  d: "M43.525 20.383c0 8.911-7.74 14.061-17.288 14.061S8.95 29.294 8.95 20.383s7.74-13.83 17.288-13.83 17.288 4.919 17.288 13.83z"
}), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 0.868
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.95 19a6.915 6.915 0 11-13.831 0 6.915 6.915 0 0113.83 0z",
  strokeWidth: 1.00040472
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.068 19A4.034 4.034 0 1115 19a4.034 4.034 0 018.068 0zM40.356 19a6.915 6.915 0 11-13.83 0 6.915 6.915 0 0113.83 0z",
  strokeWidth: 1.00040472
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.474 19a4.034 4.034 0 11-8.067 0 4.034 4.034 0 018.067 0z",
  strokeWidth: 1.00040472
})), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 0.868
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.054 17.726a.576.576 0 11-1.152 0 .576.576 0 011.152 0zM32.691 17.726a.576.576 0 11-1.152 0 .576.576 0 011.152 0z",
  strokeWidth: 1.00040472
})), /*#__PURE__*/React.createElement("path", {
  d: "M29.695 24.147c0 1.782-3.458 5.378-3.458 5.378s-3.457-3.596-3.457-5.378c0-1.783 1.548-2.69 3.457-2.69 1.91 0 3.458.907 3.458 2.69z"
}), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.134
}, /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1 0 0 .77717 62.544 10.716)",
  d: "M-39.125 33.563c-1.734 0-3.156.818-3.156 2.437 0 1.619 3.156 4.875 3.156 4.875s.304-.364.719-.844a24.389 24.389 0 002.031 2.469s1.127-1.18 2.031-2.469c.415.48.719.844.719.844s3.156-3.256 3.156-4.875c0-1.619-1.422-2.438-3.156-2.438"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-33.235 1029.805c0 1.618-3.14 4.884-3.14 4.884s-3.14-3.266-3.14-4.884c0-1.619 1.406-2.443 3.14-2.443 1.734 0 3.14.824 3.14 2.443z",
  transform: "matrix(1 0 0 .77717 62.544 -763.63)"
})));

var SvgOwl = function SvgOwl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOwl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Owl.45b3b935.svg";
export { ForwardRef as ReactComponent };